
import userService from 'UserService';
import restService from 'RestService';

class AccountService {
    verifyResponsive(){
        return new Promise((resolve)=>{
            const features = userService.getUserFeatures();
            resolve(features.MobileViews);
        });
    }

    verifyEncrypted() {
        return new Promise((resolve)=>{
            const features = userService.getUserFeatures();
            resolve(features.Encrypted);
        });
    }

    verifyEmailAttachments(){
        const features = userService.getUserFeatures();
        return features.NotificationAttachments;
    }


    getDetailsForDesigner() {

        return restService.getDetailsForDesigner()
        .catch(err => {
            console.log('Error loading account details', err);
            throw err;
        });
    }
}

const accountService = new AccountService();
export default accountService;
